<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
    <h4>{{ this.$t('BusinessPurchaseApplyDetail.reviewResult') }}</h4>
      <el-radio-group v-model="form.auditResult">
        <el-radio label="1">{{ this.$t('BusinessPurchaseApplyDetail.reviewResult2') }}</el-radio>
        <el-radio label="2">{{ this.$t('BusinessPurchaseApplyDetail.reviewResult1') }}</el-radio>
      </el-radio-group>
    <h4>{{ this.$t('BusinessPurchaseApplyDetail.reviewRemark') }}</h4>
    <BjInput
      v-model="form.remark"
      type="textarea"
      :placeholder="$t('inputText')"
      maxlength="2000"
      show-word-limit
      clearable
      rows="5"
    ></BjInput>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      title: this.$t('approvedText'),
      form: {
        auditResult: null,
        remark: null,
      }
    };
  },
  methods: {
    handleClose(done) {
      this.hide();
    },
    show(title) {
      this.title = title;
      this.form.auditResult = null;
      this.form.remark = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          if (!this.form.auditResult) return this.$message.error(this.$t('BusinessPurchaseApplyDetail.errorMsg1'));
          let data = {};
             data = {
              remark: this.form.remark,
              auditResult: this.form.auditResult === '1' ? '1' : '2',
            };
          this.$emit('confirm', data);
          this.hide();
        })
        .catch(_ => {});
    },
  },
};
</script>

<style></style>
